import { faker } from '@faker-js/faker';

const DEVICE_ID_KEY = 'ai-or-not:device-id';
const PLAYER_NAME_KEY = 'ai-or-not:player-name';

function createFallbackUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (token) => {
    const value = Math.floor(Math.random() * 16);
    const replacement = token === 'x' ? value : (value & 0x3) | 0x8;

    return replacement.toString(16);
  });
}

export function getOrCreateDeviceId() {
  const storedDeviceId = window.localStorage.getItem(DEVICE_ID_KEY);

  if (storedDeviceId) {
    return storedDeviceId;
  }

  const nextDeviceId =
    window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : createFallbackUuid();

  window.localStorage.setItem(DEVICE_ID_KEY, nextDeviceId);

  return nextDeviceId;
}

function createGeneratedPlayerName() {
  return faker.internet.username();
}

export function getOrCreatePlayerName() {
  const storedPlayerName = window.localStorage.getItem(PLAYER_NAME_KEY);

  if (storedPlayerName) {
    return storedPlayerName;
  }

  const nextPlayerName = createGeneratedPlayerName();

  window.localStorage.setItem(PLAYER_NAME_KEY, nextPlayerName);

  return nextPlayerName;
}

export function savePlayerName(playerName) {
  const trimmedPlayerName = playerName.trim();
  const nextPlayerName = trimmedPlayerName || createGeneratedPlayerName();

  window.localStorage.setItem(PLAYER_NAME_KEY, nextPlayerName);

  return nextPlayerName;
}

export function resetDeviceId() {
  window.localStorage.removeItem(DEVICE_ID_KEY);

  return getOrCreateDeviceId();
}

export { DEVICE_ID_KEY, PLAYER_NAME_KEY };
